// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--jp-position-career-breadcrumb{
    width: 100%;
    height: 72px;
    padding-left: 139px;
}

.scl--jpcb-con-st{
    width: 276px;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 1px;
}

.scl--jpcb-con-st h3, .scl--jpcb-con-st span{
    margin: 0px;
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: lighter;
    color: rgba(125, 129, 135, 1);
}

.scl--jpcb-con-st h3{
    cursor: pointer;
}

.scl--jpcb-con-st h3:hover{
    text-decoration: underline;
}

.scl--jpcb-con-st h4{
    margin: 0px;
    font-size: 18px;
    font-family: var(--primary-font);
    font-weight: lighter;
}

@media (max-width: 850px) {
    .scl--jp-position-career-breadcrumb{
        padding-left: var(--global-tablet-padding-left);
        padding-right: var(--global-tablet-padding-right);
    }
}

@media (max-width: 500px) {
    .scl--jp-position-career-breadcrumb{
        padding-left: var(--global-mobile-padding-left);
        padding-right: var(--global-mobile-padding-right);
    }
}`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/job-position/css/jp_Breadcrumb.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;AACJ;;AAEA;IACI;QACI,+CAA+C;QAC/C,iDAAiD;IACrD;AACJ","sourcesContent":[".scl--jp-position-career-breadcrumb{\n    width: 100%;\n    height: 72px;\n    padding-left: 139px;\n}\n\n.scl--jpcb-con-st{\n    width: 276px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding-bottom: 1px;\n}\n\n.scl--jpcb-con-st h3, .scl--jpcb-con-st span{\n    margin: 0px;\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n    color: rgba(125, 129, 135, 1);\n}\n\n.scl--jpcb-con-st h3{\n    cursor: pointer;\n}\n\n.scl--jpcb-con-st h3:hover{\n    text-decoration: underline;\n}\n\n.scl--jpcb-con-st h4{\n    margin: 0px;\n    font-size: 18px;\n    font-family: var(--primary-font);\n    font-weight: lighter;\n}\n\n@media (max-width: 850px) {\n    .scl--jp-position-career-breadcrumb{\n        padding-left: var(--global-tablet-padding-left);\n        padding-right: var(--global-tablet-padding-right);\n    }\n}\n\n@media (max-width: 500px) {\n    .scl--jp-position-career-breadcrumb{\n        padding-left: var(--global-mobile-padding-left);\n        padding-right: var(--global-mobile-padding-right);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
